module.exports = __webpack_public_path__ + "img/suporte-02.0a133c68.webp";